// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2sNzp","title":"ClientReferral_title__2Df8r","itemText":"ClientReferral_itemText__3r5bs"};